import { useEffect, useState } from 'react';
import './lsc.scss';
import userApi from 'apis/userApi';
import classNames from 'classnames';

interface Props {
    onClose: () => void;
}

interface listHisMini {
    id: string;
    issue: string;
    bettime: any;
    txtBet: string;
    winnumber: string;
    amount: number;
    bonus: number;
    statusname: string;
    status: string;
}

export default function LSCXDMiniGame(props: Props) {
    const { onClose } = props;

    const [totalNum, setTotalNum] = useState<number>(0);
    const [tamount, setTamount] = useState<number>(0);
    const [twin, setTwin] = useState<number>(0);
    const [listHis, setListHis] = useState<listHisMini[]>([]);

    const submit = async () => {
        const currentDate = new Date();
        let starttime = new Date(currentDate);
        starttime.setDate(starttime.getDate() - 35);
        const param = {
            lotteryid: 403,
        };

          try {
            const { data } = await userApi.lotteryRecordBean('btnSearch', param);
            if (!data.msg) {
                const getResList = data["reslist"];
                customizeRes(getResList);
                getResList.map((elm: any) => {
                    elm.codes = customizedDetailCode(elm.codes);
                });
                setListHis(getResList);
                setTotalNum(data["totalrecord"]);
                setTamount(data["tamount"]);
                setTwin(data["twin"]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const customizeRes = (getResList: any) => {
        getResList.map((item: any) => {
            item["bettime"] = item["bettime"].replace(/-/g, "/");
            return item;
        });
    }

    const customizedDetailCode = (code: string) => {
        let optiCode = '';
        optiCode = code
                .replace('[Even]', '[Chẵn] ')
                .replace('[Odd]', '[Lẻ] ')
                .replace('[odd]', '[Lẻ] ')
                .replace('[even]', '[Chẵn] ')
                .replace('[Even]', '[Chẵn] ')
                .replace('[Red]', '[Đỏ] ')
                .replace('[red]', '[Đỏ] ')
                .replace('[White]', '[Trắng] ')
                .replace('[white]', '[Trắng] ')
                .replace('[1white3red]', '[1 trắng 3 đỏ] ')
                .replace('[3white1red]', '[3 trắng 1 đỏ] ')
                .replace('[cua]', '[Cua] ')
                .replace('[ga]', '[Gà] ')
                .replace('[bau]', '[Bầu] ')
                .replace('[ca]', '[Cá] ')
                .replace('[tom]', '[Tôm] ')
                .replace('[nai]', '[Nai] ');
            optiCode = optiCode.replace(/Prize/g, 'Thắng').replace(/ Bet/g, 'Cược').replace(/Bet/g, 'Cược').replace(/,,/g, '<br/>');
        return optiCode;
    };

    useEffect(() => {
        submit();
    }, []);

    return (
        <>
            <div id="lscXD">
                <section className="MiniGames BauCua1GiayGame">
                    <div className="historyBetUser layui-layer-wrap">
                        <h3 className="title">LỊCH SỬ CƯỢC</h3>
                        <div className="closeHis" onClick={onClose}>
                            <img src={require(`assets/images/txcanban/statis/close.png`)} alt='' />
                        </div>
                        <div className="inner">
                                <ul className="totalbet">
                                    <li>
                                        Tổng Cược: <strong>{ Number(tamount) }</strong>
                                    </li>
                                    <li>
                                        Tổng Trúng: <strong>{ Number(twin) }</strong>
                                    </li>
                                    <li>
                                        Số Lượt Chơi: <strong>{ totalNum }</strong>
                                    </li>
                                </ul>
                            <div className="content">
                                <div className="innerTblScroll">
                                    <table className="table-history">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Lượt xổ</th>
                                                <th>Thời gian</th>
                                                <th>Kết quả</th>
                                                <th>Cược</th>
                                                <th>Thắng</th>
                                                <th>Trạng thái</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listHis.length === 0 ? (
                                                <tr>
                                                    <td>Không có dữ liệu</td>
                                                </tr>
                                            ) : (
                                                listHis.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>{ item.id }</td>
                                                        <td>{ item.issue }</td>
                                                        <td>{ item.bettime }</td>
                                                        <td className="oneLineVi">
                                                            <span className={`vi bet-vi-color${item.winnumber.split('')[0]}`}></span>
                                                            <span className={`vi bet-vi-color${item.winnumber.split('')[1]}`}></span>
                                                            <span className={`vi bet-vi-color${item.winnumber.split('')[2]}`}></span>
                                                            <span className={`vi bet-vi-color${item.winnumber.split('')[3]}`}></span>
                                                        </td>
                                                        <td>{ Number(item.amount) }</td>
                                                        <td className={classNames("win", { bonus: item.bonus > 0 })}>{ item.bonus }</td>
                                                        <td><span className={`state state-${item.status}`}>{item.statusname}</span></td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
